import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProfileImage from "../../components/ProfileImage";

export default function Photos({ username, token, photos }) {
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();

  const displayPhotos = showAll ? photos.resources : photos.resources?.slice(0, 9);

  const handlePhotoClick = (photo) => {
    // Navigate to the post containing this photo
    if (photo.postId) {
      navigate(`/post/${photo.postId}`);
    }
  };

  return (
    <div className="profile_card">
      <div className="profile_card_header">
        Photos
        <div 
          className="profile_header_link"
          onClick={() => setShowAll(!showAll)}
          style={{ cursor: "pointer" }}
        >
          {showAll ? "Show less" : "See all photos"}
        </div>
      </div>
      <div className="profile_card_count">
        {photos.total_count === 0
          ? "No photos"
          : photos.total_count === 1
          ? "1 Photo"
          : `${photos.total_count} photos`}
      </div>
      {photos.total_count > 0 && (
        <div className={`profile_card_grid ${showAll ? "show_all_photos" : ""}`}>
          {displayPhotos &&
            displayPhotos.map((photo, index) => (
              <div 
                className="profile_photo_card" 
                key={`${photo.postId}-${index}`}
                onClick={() => handlePhotoClick(photo)}
                style={{ cursor: "pointer" }}
              >
                <ProfileImage 
                  src={photo.url} 
                  alt="Profile photo"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '15px' }}
                  placeholderText="Photo not available"
                />
              </div>
            ))}
        </div>
      )}
      {photos.total_count === 0 && (
        <div className="no_photos">
          <div style={{ 
            textAlign: "center", 
            padding: "20px", 
            color: "#65676b",
            fontSize: "14px"
          }}>
            No photos to show
          </div>
        </div>
      )}
    </div>
  );
}
